<template>
  <div :class="[!v2 ? item.soldat ? 'product-header-item soldat' : 'product-header-item' : '', { '-watch-clinic': clinic }]" @click="productZoomGallery === true && handleOpenZoomGallery()">
    <lazy-image :class-name="item.soldat ? 'product-header-item-image soldat' : 'product-header-item-image'" ref="picture" :item="picture" :sizes="sizes" rootMargin="0px" :loading="loading" :render-when-appeared="renderWhenAppeared"></lazy-image>
  </div>
</template>

<script>
import { ReadyHook } from 'vue-asyncready'
import ImageManager from 'vue-storefront-prismic-ssr/utilities/ImageManager'
import LazyImage from './utils/LazyImage'

export default {
  props: ['item', 'index', 'v2', 'clinic', 'render-when-appeared', 'loading', 'productZoomGallery'],
  name: 'ProductHeaderItem',
  mixins: [ReadyHook],
  components: {
    LazyImage
  },
  computed: {
    picture() {
      if (this.item.soldat) {
        return {
          url: this.item.src,
          lowDefinitionUrl: ImageManager.getLowDefinition(this.item.src, 150, 1.4285714286, true, 4),
          srcset: ImageManager.getSrcSet(this.item.src, 1200, 200, 100, 1.4285714286, true),
          alt: '',
          width: this.item.width,
          height: this.item.height
        }
      } else {
        return {
          url: this.item.src,
          lowDefinitionUrl: ImageManager.getLowDefinition(this.item.src, 150, 1, true),
          srcset: ImageManager.getSrcSet(this.item.src, 1600, 600, 100, 1, true),
          alt: '',
          width: this.item.width,
          height: this.item.height
        }
      }
    },
    sizes() {
      if (this.item.soldat) {
        return '(max-width: 575px) 80vw, (max-width: 991px) 50vw, 35vw'
      } else {
        return '(max-width: 992px) 100vw, 70vw'
      }
    }
  },
  methods: {
    handleOpenZoomGallery() {
      this.$emit('click')
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~theme/css/core';
.product-header-item {
  width:100%;
  height: 100%;

  &:not(.-watch-clinic) {
    .product-header-item-image {
      width:100%;
      height: 100%;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);

      /deep/ img {
        width: 100%;
        height:100%;
        object-fit: cover;
      }

      &.soldat {
        max-height: 72vh;
        width: 70%;

        @media (min-width: 321px) {
          width: 80%;
        }
        @include bp(sm) {
          width: 65%;
        }
        @include bp(md) {
          width: 48%;
        }
        @include bp(lg) {
          height: 55rem;
          width: 70%;
        }
        /deep/ img {
          object-fit: contain;
        }
      }
    }
  }
}
</style>
